import { flatten as _flatten, uniq as _uniq } from 'lodash-es';
import { ReplaySubject } from 'rxjs';
import { bufferTime, filter, map } from 'rxjs/operators';

export class BufferQueue<T> {
  private bufferSubject$ = new ReplaySubject<T>(1);

  bufferedQueue$ = this.bufferSubject$.pipe(
    bufferTime(this.bufferTimeMs),
    map(i => [i]),
    map(i => _uniq(_flatten(i))),
    filter(r => r.length > 0),
  );

  /**
   *
   */
  constructor(public bufferTimeMs: number = 20) {
  }

  addItem(item: T) {
    this.bufferSubject$.next(item);
  }
}
